/**
 * SingleKeyboardNav
 * ======================================
 * - close popup layers when esc pressed
 */
class SingleKeyboardNav {
	constructor() {
    this.canvas = document.querySelector('section.detail ul')

    if(!this.canvas){
      return
    }

		document.addEventListener('keyup', this.keyHandler, false)
	}

	keyHandler = evt => {
		evt = evt || window.event

    if (evt.keyCode == '38') {
      this.moveToPrev()
    }
    else if (evt.keyCode == '40') {
      this.moveToNext()
    }
    else if (evt.keyCode == '37') {
      this.moveToPrev()
    }
    else if (evt.keyCode == '39') {
      this.moveToNext()
    }
	}

  moveToPrev = () => {
    const currentPosition = this.canvas.scrollTop

    this.canvas.scroll({
      top: currentPosition - window.innerHeight,
      left: 0,
      behavior: 'smooth'
    });
  }

  moveToNext = () => {
    const currentPosition = this.canvas.scrollTop

    this.canvas.scroll({
      top: currentPosition + window.innerHeight,
      left: 0,
      behavior: 'smooth'
    });
  }

}

new SingleKeyboardNav()
